module.exports = __webpack_public_path__ + "static/img/index21.68f84e9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index21.gif
// module id = Dvxw
// module chunks = 0